import { render, staticRenderFns } from "./privacy-tip.vue?vue&type=template&id=95644150&scoped=true&"
import script from "./privacy-tip.vue?vue&type=script&lang=js&"
export * from "./privacy-tip.vue?vue&type=script&lang=js&"
import style0 from "./privacy-tip.vue?vue&type=style&index=0&id=95644150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95644150",
  null
  
)

export default component.exports